import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyState } from 'components/ui/EmptyState';
import { NsKey } from 'enums/NsKey';
import { useNote } from '../contexts/NoteContext';
import NoteListItem from './NoteListItem';
import { NotebookPen } from 'lucide-react';

const NoteList: FC = () => {
  const { t } = useTranslation(NsKey.Note);
  const { notes, selectedNote, selectNote } = useNote();

  if (notes.length === 0) {
    return (
      <EmptyState
        icon={<NotebookPen className="w-8 h-8 text-slate-400" />}
        title={t('EMPTY_STATE.TITLE')}
        description={t('EMPTY_STATE.DESCRIPTION')}
        className="bg-white rounded-2xl border border-slate-200/60"
      />
    );
  }

  return (
    <div className="flex flex-col gap-3">
      {notes.map((note) => (
        <NoteListItem
          key={note.id}
          item={note}
          isSelected={selectedNote?.id === note.id}
          onClick={() => selectNote(note)}
        />
      ))}
    </div>
  );
};

export default NoteList;
